import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import cx from "classnames";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import styles from "assets/jss/material-dashboard-react/views/modalStyle";
import DealShareDetails from "./DealShareDetails";
const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const DealShareModal = ({partnerDealCode, partnerDealData, closeModal, showModal}) => {
  const classes = useStyles();
  const handleClose = () => {
    closeModal();
  };
  return (
    <div className={classes.container}>
      <Dialog
        classes={{
          root: classes.center,
        }}
        maxWidth="lg"
        open={showModal}
        fullScreen={true}
        
        disableEscapeKeyDown
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogContent
          id="classic-modal-slide-description"
          className={cx(classes.modalBody, classes.loginMaxWidth)}
          justifyContent="center"
        >
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <DealShareDetails
                partnerDealCode={partnerDealCode}
                partnerDealData={partnerDealData}
                closeModal={closeModal}
                showModal={showModal}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>
      </Dialog>
    </div>
  );
};
DealShareModal.propTypes = {
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  record: PropTypes.object,
};
export default DealShareModal;